@if (this.katalogSkupinSablonState.vm$ | async; as data) {
<div class="nadpis">
  <p class="large-text">Zadejte kritéria skupin typu oprávnění k zastupování, které chcete vyhledat.</p>
</div>

<ui-form #form [formGroup]="filterForm" (handleSubmit)="submitFilter()" class="mb-3">
  <p-accordion [multiple]="true" [activeIndex]="accordionActiveIndexArr">
    <p-accordionTab>
      <ng-template pTemplate="header"> Rozšířené filtrování </ng-template>
      <reza-katalog-skupin-sablon-filter></reza-katalog-skupin-sablon-filter>
      <ui-buttons>
        <button label="Vyhledat" class="wider" type="submit" pButton data-cy="katalog-skupin-btn-submit-kriteria"></button>
        <button
          label="Smazat kritéria"
          type="button"
          (click)="clearFilter()"
          class="p-button-outlined wider"
          data-cy="katalog-skupin-btn-smazat-kriteria"
          pButton></button>
      </ui-buttons>
    </p-accordionTab>
  </p-accordion>
</ui-form>

<p-table
  #table
  (onLazyLoad)="onLazyLoad($event)"
  [lazy]="true"
  [lazyLoadOnInit]="false"
  [scrollable]="true"
  [scrollHeight]="dynamicHeight"
  [value]="data.result.content || []"
  [paginator]="true"
  [rows]="data.filter.pageAndSortList?.count"
  [first]="data.filter.pageAndSortList?.start"
  [totalRecords]="data.result.total || 0"
  [rowsPerPageOptions]="DEFAULT_PAGE_OPTION"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem', 'margin-top': '0px' }"
  styleClass="p-datatable-lg"
  currentPageReportTemplate="Zobrazeno {first}-{last} z {totalRecords} záznamů"
  paginatorDropdownAppendTo="body"
  responsiveLayout="scroll"
  contentTemplate>
  <ng-template pTemplate="header">
    <tr>
      <th>Kód skupiny šablon</th>
      <th>Název skupiny šablon</th>
      <th>Datum vytvoření</th>
      <th>Datum poslední změny</th>
      <th>Datum ukončení</th>
      <th>Editor</th>
      <th>Status</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-skupina>
    <tr>
      <td>
        <a [routerLink]="" (click)="downloadPdf(skupina.id)" target="_blank" class="link">
          {{ skupina.kodSkupiny }}
        </a>
      </td>
      <td>{{ skupina.nazevSkupiny }}</td>
      <td>{{ skupina.datumVytvoreni | date : 'dd.MM.yyyy' }}</td>
      <td>{{ skupina.datumPosledniZmeny | date : 'dd.MM.yyyy' }}</td>
      <td>{{ skupina.datumUkonceni | date : 'dd.MM.yyyy' }}</td>
      <td>
        @if (skupina.editor?.kodOvm && skupina.editor?.nazevOvm) {
        {{ skupina.editor.kodOvm }} - {{ skupina.editor.nazevOvm }}
        } @else {
        {{ skupina.editor?.kodOvm || skupina.editor?.nazevOvm }}
        }
      </td>
      <td>
        <ui-status-indicator
          [statusLabels]="statusSkupinySablonOptions"
          [status]="skupina.status"></ui-status-indicator>
      </td>
    </tr>
  </ng-template>
</p-table>
<ui-buttons>
  <button class="m-1 mb-4" label="Zpět" (click)="goBack()" pButton></button>
</ui-buttons>
}
